import { z } from 'zod';

/** Erro da API no formato RFC 9457 (`application/problem+json`), com mensagens em PT-BR. */
export const ProblemSchema = z
  .object({
    type: z.string().meta({ description: 'URI do tipo de erro (`about:blank` quando genérico).' }),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    instance: z.string().optional(),
    code: z
      .string()
      .optional()
      .meta({ description: 'Código estável para a interface (ex.: `version_conflict`).' }),
    errors: z
      .array(z.object({ path: z.string(), message: z.string() }))
      .optional()
      .meta({ description: 'Erros de validação, campo a campo.' }),
  })
  .meta({ id: 'Problem' });

export type Problem = z.infer<typeof ProblemSchema>;
